import Axios from 'axios'

const reportRescheduleService = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.RESCHEDULE_REPORT
    return AxiosInstance
  },
  getRescheduleReport(data) {
    return this.axios().get(
      'report?' + 'startDate=' + data.releaseDateStart + '&endDate=' + data.releaseDateEnd + '&type=' + data.exportWay,
      { responseType: 'arraybuffer' }
    )
  }
}

export default reportRescheduleService
